module.exports = {"Administración de paquetes":"Administración de paquetes","Listado de paquetes":"Listado de paquetes","Nombre":"Nombre","Servicio":"Servicio","Ver paquete":"Ver paquete","Editar paquete":"Editar paquete","Nuevo paquete":"Nuevo paquete","Código":"Código","Nuevo Paquete":"Nuevo Paquete","Nombre Servicio":"Nombre Servicio","Cantidad Sesiones":"Cantidad Sesiones","Nombre Categoría":"Nombre Categoría","Monto":"Monto","Rango fecha Inicio/Fin invalido":"Rango fecha Inicio/Fin invalido","Monto Sesion":"Monto Sesión","Moneda":"Moneda","Inicio":"Inicio","Fin":"Fin","Número":"Número"}


//////////////////
// WEBPACK FOOTER
// ./src/i18n/paquetes/es.json
// module id = 1422
// module chunks = 0